import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";

export interface CounterItemProps {
    className?: string;
    text?: string | number;
}

const StyledTopTypography = styled(Typography)({
    display: "block",
    letterSpacing: "1px",
});

const CounterItem = ({ className, text }: CounterItemProps) => (
    <span className={className}>
        <StyledTopTypography variant={"body2Highlight"}>
            {typeof text === "number" ? text.toString().padStart(2, "0") : text}
        </StyledTopTypography>
    </span>
);

export default CounterItem;
